
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import CustomBreadCrumbs from "components/ReuseableCompos/CustomBreadCrumbs";
import CustomContentLoader from "components/ReuseableCompos/CustomContentLoader";
import CustomJumbotron from "components/ReuseableCompos/CustomJumbotron";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import SEO from "components/Seo";
import { useAuthContext } from "context/AuthContext";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import useUtilities from "../customHooks/useUtilities";
import newEvent from "../public/lottie/teamsupport.json";
const Create = () => {
    const { t } = useTranslation("common");
    const { data: utilities } = useUtilities();
    const { donor } = useAuthContext();
    const { locale, push } = useRouter();
    const Lottie = dynamic(() => import("lottie-react"), {
        loading: () => (<CustomContentLoader viewBox={`0 0 1200 225`} className="pb-3">
        <rect x="calc(50% - 117px)" y="0" rx="8" ry="8" width="225" height="225"></rect>
      </CustomContentLoader>)
    });
    const isMobile = useMobile("lg");
    return (
    //SEO in layout
    <>
      <SEO title={t("team_support_title")} description={t("team_support_desc")}/>
      <CustomJumbotron p="py-4" breadCrumbM="my-0" m="mt-0" className="mt-0 ps-2 ps-sm-0 border-bottom" title={t(`team_support_title`)} desc={t(`team_support_desc`)} customBreadCrumbs={<CustomBreadCrumbs transformedLabel={(label) => {
                return t("team_support_title");
            }}/>}/>
      <div className="container">
        <div className="mb-5">
          <div className="">
            <Lottie className="m-auto pb-3" style={{ width: 300 }} animationData={newEvent} loop={true}/>

            <p className="text-center fs-18 fw-medium my-4" style={{
            lineHeight: 2
        }} dangerouslySetInnerHTML={{
            __html: t("team_support_intro")
        }}></p>

            <div className="d-flex justify-content-center">
              <MolhamButton id="event-open-create-btn" startIcon="fe-heart" label={t(`team_support_btn`)} className={isMobile && `w-100`} onClick={() => push("?id=4#quick_donate")}/>
            </div>
          </div>
        </div>
      </div>
    </>);
};
export default Create;
const toDataURI = async (url: string) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
            resolve(xhr.response);
        };
        xhr.onerror = () => {
            reject(xhr.statusText);
        };
        xhr.responseType = "blob";
        xhr.open("GET", url);
        xhr.send();
    });
};

    async function __Next_Translate__getStaticProps__1a13f66bded__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/team-support',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bded__ as getStaticProps }
  